// src/pages/user/UserDashboard.tsx
import UserDashboard from "../../components/user/UserDasboard";

export default function UserDashboardPage() {
  return <UserDashboard />;
}
